<template>
  <div class="initialConfigPage_box">
    <!--欢迎-->
    <div class="welcome_box">
      <Icon size="20" type="ios-home-outline"/>
      <span class="font-size-14 ml2">{{ $t('key1002561') }}</span>
    </div>
    <!--logo区域-->
    <div class="logo_box">
      <div class="flex align-items-center">
        <h2 class="font-size-17 color-333 font-weight-bold">{{ 'Hi，' + systemName }}</h2>
        <span class="font-size-13 color-333 font-weight-bold ml25">{{ $t('key1002562') }}</span>
      </div>
      <img :src="tongToolLogo" width="250" height="22" alt="">
    </div>
    <!--配置区域-->
    <div class="config_box">
      <Steps :current="currentIndex" size="small">
        <Step :title="$t('key1002551')"></Step>
        <Step :title="$t('key1002552')"></Step>
        <Step :title="$t('key1002553')"></Step>
        <Step :title="$t('key1002554')"></Step>
      </Steps>
      <Alert class="mt30 mb30">
        <div class="flex align-items-center">
          <Icon size="20" color="#2D8CF0" class="position-relative" style="top: -1px" type="md-alert"/>
          <span class="font-size-14 color-333 font-weight-bold ml8">{{ $t('key1002563') }}</span>
        </div>
        <div slot="desc" class="font-size-13 pl27">
          {{ $t('key1002564') }}<br/>
          {{ $t('key1002565') }}<span class="themeColor">{{ $t('key1002566') }}</span>{{ $t('key1002567') }}
        </div>
      </Alert>
      <!--运营端配置区域-->
      <Form :model="ymsConfigForm" ref="ymsConfigForm" :rules="ymsConfigRuleValidate" :label-width="100" @submit.native.prevent v-show="currentIndex === 0">
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002555')" class="radio_styles" prop="language">
              <RadioGroup v-model="ymsConfigForm.language">
                <Radio v-for="item in ymsLanguagesList" :label="item.value">{{ item.name }}</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002556')" class="radio_styles" prop="language">
              <Select v-model="ymsConfigForm.platformCurrency" filterable class="width_250">
                <Option v-for="(item, itemIndex) in currencyList" :key="itemIndex" :value="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="LOGO：" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'ymsLogo')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'ymsLogo')"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'img')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box" v-if="ymsConfigForm.ymsLogo">
                  <img :src="ymsConfigForm.ymsLogo" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002568') }}</p>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002557')" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'ymsIcon')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'ymsIcon')"
                :format="['ico']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'ico')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box ico" v-if="ymsConfigForm.ymsIcon">
                  <img :src="ymsConfigForm.ymsIcon" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002569') }}</p>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!--分销商端配置区域-->
      <Form :model="distributorConfigForm" ref="distributorConfigForm" :rules="distributorConfigRuleValidate"
        :label-width="100" @submit.native.prevent v-show="currentIndex === 1">
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002558')" prop="languagesList" :show-message="isStepActive(1)">
              <CheckboxGroup v-model="distributorConfigForm.languagesList" class="languages_check_box">
                <Checkbox v-for="item in distributorLanguagesList" :label="item.value" class="languages_check_boxItem">
                  <div class="flex align-items-center">
                    <span class="ml5 mr7">{{ item.name }}</span>
                    <span v-if="item.setAsDefault && distributorConfigForm.languagesList.includes(item.value)"
                      class="font-size-12 color-666 ml4">{{ $t('key1002570') }}</span>
                    <span v-if="!item.setAsDefault && distributorConfigForm.languagesList.includes(item.value)"
                      class="font-size-12 themeColor cursor ml4" @click="(event) => setAsDefaultBtn(item, 'distributor', event)">{{ $t('key1002571') }}</span>
                  </div>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002559')" :label-width="150" prop="platformList" :show-message="isStepActive(1)">
              <CheckboxGroup v-model="distributorConfigForm.platformList" class="languages_check_box">
                <Checkbox v-for="item in distributorPlatformData" :label="item.value" class="languages_check_boxItem">
                  <span class="ml4">{{ item.name }}</span>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="LOGO：" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'distributorLogo')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'distributorLogo')"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'img')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box" v-if="distributorConfigForm.distributorLogo">
                  <img :src="distributorConfigForm.distributorLogo" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002568') }}</p>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002557')" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'distributorIcon')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'distributorIcon')"
                :format="['ico']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'ico')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box ico" v-if="distributorConfigForm.distributorIcon">
                  <img :src="distributorConfigForm.distributorIcon" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002569') }}</p>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <!--供应商端配置区域-->
      <Form :model="supplierConfigForm" ref="supplierConfigForm" :rules="supplierConfigRuleValidate"
        :label-width="100" @submit.native.prevent v-show="currentIndex === 2">
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002558')" prop="languagesList" :show-message="isStepActive(1)">
              <CheckboxGroup v-model="supplierConfigForm.languagesList" class="languages_check_box">
                <Checkbox v-for="item in supplierLanguagesList" :label="item.value" class="languages_check_boxItem">
                  <div class="flex align-items-center">
                    <span class="ml5 mr7">{{ item.name }}</span>
                    <span v-if="item.setAsDefault && supplierConfigForm.languagesList.includes(item.value)"
                      class="font-size-12 color-666 ml4">{{ $t('key1002570') }}</span>
                    <span v-if="!item.setAsDefault && supplierConfigForm.languagesList.includes(item.value)"
                      class="font-size-12 themeColor cursor ml4" @click="(event) => setAsDefaultBtn(item, 'supplier', event)">{{ $t('key1002571') }}</span>
                  </div>
                </Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="LOGO：" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'supplierLogo')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'supplierLogo')"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'img')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box" v-if="supplierConfigForm.supplierLogo">
                  <img :src="supplierConfigForm.supplierLogo" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002568') }}</p>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002557')" class="required_style_label">
              <Upload
                class="upload_styles"
                ref="upload"
                type="drag"
                name="files"
                :headers="headObj"
                :action="fileApi"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="file => beforeUpload(file, 'supplierIcon')"
                :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, 'supplierIcon')"
                :format="['ico']"
                :max-size="20480"
                :on-format-error="(file, fileList)=>handleFormatError(file, fileList, 'ico')"
                :on-exceeded-size="handleMaxSize">
                <div class="preview_box ico" v-if="supplierConfigForm.supplierIcon">
                  <img :src="supplierConfigForm.supplierIcon" alt=""/>
                  <div class="preview_mask">{{ $t('key1002385') }}</div>
                </div>
                <div class="upload_icon_box" v-else>
                  <Icon type="md-add" size="22" class="position-relative" style="top: 4px;" color="#3399ff"/>
                  <span class="font-size-12">{{ $t('key1002386') }}</span>
                </div>
              </Upload>
              <p class="font-size-12 color-666">{{ $t('key1002569') }}</p>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <!--下一步、提交-->
    <div class="options_content">
      <Button class="mr20" v-if="currentIndex > 0" @click="previousStepBtn">{{ $t('key1000725') }}</Button>
      <Button type="primary" @click="initialConfigBtn">{{ currentIndex === 2 ? $t('key1000367') : $t('key1002560') }}</Button>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getCurrencyData, commonLocalStorage, saveErpCommonSettingParam, getDataSetBatchList} from "@/utils/common";

// 图片校验规则（唯一数据源）
const IMAGE_RULES = {
  ymsLogo: {width: 210, height: 22, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002536'), isIcon: false},
  distributorLogo: {width: 210, height: 22, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002537'), isIcon: false},
  supplierLogo: {width: 210, height: 22, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002538'), isIcon: false},

  ymsIcon: {width: 16, height: 16, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002539'), isIcon: true},
  distributorIcon: {width: 16, height: 16, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002540'), isIcon: true},
  supplierIcon: {width: 16, height: 16, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002541'), isIcon: true},
};

export default {
  name: 'initialConfigPage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tongToolLogo: require('@/assets/images/tongTool.png'),
      currentIndex: 0,
      ymsConfigForm: {
        ymsLogo: null,
        language: 'CN',
        platformCurrency: 'CNY',
        ymsIcon: null,
      },
      ymsConfigRuleValidate: {
        language: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002542'), trigger: 'change'},
        ],
        platformCurrency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002543'), trigger: 'change'},
        ]
      },
      distributorConfigForm: {
        distributorLogo: null,
        distributorIcon: null,
        platformList: [],
        languagesList: []
      },
      distributorConfigRuleValidate: {
        languagesList: [
          {required: true, type: 'array', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002542'), trigger: 'change'},
        ],
        platformList: [
          {required: true, type: 'array', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002544'), trigger: 'change'}
        ]
      },
      supplierConfigForm: {
        supplierLogo: null,
        supplierIcon: null,
        languagesList: []
      },
      supplierConfigRuleValidate: {
        languagesList: [
          {required: true, type: 'array', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002542'), trigger: 'change'}
        ]
      },
      currencyList: [],
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"&isOriginalName=true&isTemp=N',
      uploadData: {},
      ymsLanguagesList: [],
      distributorLanguagesList: [],
      supplierLanguagesList: [],
      distributorPlatformData: [],
      enumData: {}
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 系统名称
    systemName() {
      return commonLocalStorage.getItem('pageConfig')?.sname || this.$store.state.pageConfig?.sname || '';
    }
  },
  created() {
    this.initialConfigData();
  },
  methods: {
    // 初始化数据
    async initialConfigData() {
      try {
        // 币种数据
        this.currencyList = await getCurrencyData();
        // 配置项的枚举数据集
        let enumMap = {};
        let enumKeyList = ['LanguageEnum', 'DistributorPlatformEnum'];
        let enumList = await getDataSetBatchList(enumKeyList);
        enumList.forEach(item => {
          enumMap[`${item.enumKey}_${item.value}`] = item.name;
        });
        this.enumData = enumMap;

        // 配置项可选值
        const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
        let distributorPlatformSetSaas = obj?.distributorPlatformSetSaas || [];
        let languageSetSaas = obj?.languageSetSaas || [];
        // 平台配置
        this.distributorPlatformData = distributorPlatformSetSaas.map(val => ({
          value: val,
          name: this.enumData[`DistributorPlatformEnum_${val}`] || ''
        }));
        // 语种配置
        const buildLanguageList = () =>
          languageSetSaas.map(i => ({
              value: i.value,
              name: this.enumData[`LanguageEnum_${i.code}`] || '',
              code: i.code,
              iconPath: i.iconPath,
              setAsDefault: false
            })
          );
        this.ymsLanguagesList = buildLanguageList();
        this.distributorLanguagesList = buildLanguageList();
        this.supplierLanguagesList = buildLanguageList();
      } catch (e) {
        console.error('initialConfigData error:', e);
      }
    },
    //上传图片成功
    uploadSuccess(response, file, fileList, type) {
      let v = this;
      let uploadList = [
        {pramsKey: 'ymsConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002536'), key: 'ymsLogo'},
        {pramsKey: 'distributorConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002537'), key: 'distributorLogo'},
        {pramsKey: 'supplierConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002538'), key: 'supplierLogo'},

        {pramsKey: 'ymsConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002539'), key: 'ymsIcon'},
        {pramsKey: 'distributorConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002540'), key: 'distributorIcon'},
        {pramsKey: 'supplierConfigForm', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002541'), key: 'supplierIcon'},
      ];
      uploadList.map((item) => {
        if (item.key === type) {
          if (response.code === 0) {
            let url = v.setImgPath(response.datas[0])
            v[item.pramsKey][item.key] = url;
            v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
          } else {
            v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${item.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
          }
        }
      });
    },
    // 校验文件格式
    handleFormatError(file, fileList, type) {
      let v = this;
      let text = type === 'img' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002545') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002546');
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002532')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002533')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000101')}${text}`,
        duration: 5
      });
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 上一步
    previousStepBtn() {
      this.currentIndex--;
      this.$forceUpdate();
    },
    // 下一步、提交
    initialConfigBtn() {
      let businessId = this.userInfo.merchantId;
      // 处理取值
      const mapSelected = (list, values, withDefault = false) => {
        return list
          .filter(i => values.includes(i.value))
          .map(i => ({
            value: i.value,
            code: i.code,
            iconPath: i.iconPath,
            ...(withDefault ? {defaultLanguage: i.setAsDefault} : {})
          }));
      }
      // 提交
      const submitAllConfig = (businessId) => {
        // logo配置
        const ymsLogoConfigValue = {
          logoImg: this.ymsConfigForm.ymsLogo,
          icoImg: this.ymsConfigForm.ymsIcon
        };
        const distributorLogoConfigValue = {
          logoImg: this.distributorConfigForm.distributorLogo,
          icoImg: this.distributorConfigForm.distributorIcon
        };
        const supplierLogoConfigValue = {
          logoImg: this.supplierConfigForm.supplierLogo,
          icoImg: this.supplierConfigForm.supplierIcon
        };
        // 语种
        const ymsLanguageList = mapSelected(this.ymsLanguagesList, [this.ymsConfigForm.language]);
        const distributorLanguageList = mapSelected(this.distributorLanguagesList, this.distributorConfigForm.languagesList, true);
        const supplierLanguageList = mapSelected(this.supplierLanguagesList, this.supplierConfigForm.languagesList, true);
        const hasDefaultLanguage = (list) => {
          return list.some(i => i.defaultLanguage === true);
        }
        // 默认语种校验
        if (!hasDefaultLanguage(distributorLanguageList)) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002547'));
          return false;
        }
        if (!hasDefaultLanguage(supplierLanguageList)) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002548'));
          return false;
        }
        // 运营端
        const ymsConfigList = [
          {businessId, paramKey: 'ymsCurrency', paramValue: this.ymsConfigForm.platformCurrency},
          {businessId, paramKey: 'ymsLogoConfig', paramValue: JSON.stringify(ymsLogoConfigValue)},
          {businessId, paramKey: 'ymsLanguage', paramValue: JSON.stringify(ymsLanguageList)}
        ];
        // 分销商端
        const distributorConfig = [
          {businessId, paramKey: 'distributorLogoConfig', paramValue: JSON.stringify(distributorLogoConfigValue)},
          {businessId, paramKey: 'distributorLanguage', paramValue: JSON.stringify(distributorLanguageList)},
          {businessId, paramKey: 'distributorPlatformSet', paramValue: JSON.stringify(this.distributorConfigForm.platformList)}
        ];
        // 供应商端
        const supplierConfig = [
          {businessId, paramKey: 'supplierLogoConfig', paramValue: JSON.stringify(supplierLogoConfigValue)},
          {businessId, paramKey: 'supplierLanguage', paramValue: JSON.stringify(supplierLanguageList)}
        ];
        saveErpCommonSettingParam([
          ...ymsConfigList,
          ...distributorConfig,
          ...supplierConfig
        ]).then(() => {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
          setTimeout(() => {
            this.$router.push('/statistics');
          }, 500);
        });
      }
      const stepValidators = [
        () => this.$refs.ymsConfigForm.validate(valid =>
          valid && this.validateStepImages('yms').then(() => this.currentIndex++)),
        () => this.$refs.distributorConfigForm.validate(valid =>
          valid && this.validateStepImages('distributor').then(() => this.currentIndex++)),
        () => this.$refs.supplierConfigForm.validate(valid =>
          valid && this.validateStepImages('supplier').then(() => submitAllConfig(businessId)))
      ];
      stepValidators[this.currentIndex]?.();
    },
    // 提交 / 下一步时校验图片
    validateStepImages(type) {
      let tasks = [];
      if (type === 'yms') {
        tasks = [
          {key: 'ymsLogo', value: this.ymsConfigForm.ymsLogo},
          {key: 'ymsIcon', value: this.ymsConfigForm.ymsIcon},
        ];
      }
      if (type === 'distributor') {
        tasks = [
          {key: 'distributorLogo', value: this.distributorConfigForm.distributorLogo},
          {key: 'distributorIcon', value: this.distributorConfigForm.distributorIcon},
        ];
      }
      if (type === 'supplier') {
        tasks = [
          {key: 'supplierLogo', value: this.supplierConfigForm.supplierLogo},
          {key: 'supplierIcon', value: this.supplierConfigForm.supplierIcon},
        ];
      }
      // 必填校验
      for (const item of tasks) {
        if (!item.value) {
          this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002534')}${IMAGE_RULES[item.key].name}`);
          return Promise.reject(false);
        }
      }
      // 尺寸校验
      return Promise.all(
        tasks.map(item =>
          this.validateImage(item.value, IMAGE_RULES[item.key])
        )
      );
    },
    // 上传前校验图片格式 & 尺寸
    beforeUpload(file, type) {
      const rule = IMAGE_RULES[type];
      if (!rule) return false;
      // 格式校验
      const imgTypes = ['image/png', 'image/jpeg'];
      const icoTypes = ['image/x-icon', 'image/vnd.microsoft.icon'];

      if (rule.isIcon) {
        if (!icoTypes.includes(file.type)) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002549'));
          return false;
        }
      } else {
        if (!imgTypes.includes(file.type)) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002550'));
          return false;
        }
      }
      // 尺寸校验
      return this.validateImage(file, rule);
    },
    // 校验图片尺寸（支持 File / URL）
    validateImage(source, rule) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const isFile = source instanceof File;
        const url = isFile ? URL.createObjectURL(source) : source;
        img.onload = () => {
          isFile && URL.revokeObjectURL(url);
          if (img.width !== rule.width || img.height !== rule.height) {
            this.$Message.error(
              `${rule.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002535')} ${rule.width} × ${rule.height}px`
            );
            reject(false);
          } else {
            resolve(true);
          }
        };
        img.onerror = () => {
          isFile && URL.revokeObjectURL(url);
          this.$Message.error(`${rule.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002376')}`);
          reject(false);
        };

        img.src = url;
      });
    },
    // 设置默认语种
    setAsDefaultBtn(obj, type, event) {
      if (event && event.stopPropagation) {
        event.stopPropagation();
        event.preventDefault && event.preventDefault();
      }
      switch (type) {
        case 'distributor':
          this.distributorLanguagesList.map((item) => {
            item.setAsDefault = false;
            if (item.value === obj.value) {
              item.setAsDefault = true;
            }
          });
          this.$forceUpdate();
          break;
        case 'supplier':
          this.supplierLanguagesList.map((item) => {
            item.setAsDefault = false;
            if (item.value === obj.value) {
              item.setAsDefault = true;
            }
          });
          this.$forceUpdate();
          break;
      }
    },
    // 清除表单校验提示
    isStepActive(step) {
      return this.currentIndex === step;
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less" scoped>
.initialConfigPage_box {
  background-color: #F6F7F9;
  padding: 12px 20px;
  min-height: 100vh;

  .welcome_box {
    width: 100%;
    background-color: #fff;
    margin-bottom: 12px;
    padding: 0 12px;
    height: 36px;
    display: flex;
    align-items: center;
  }

  .logo_box {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    background-color: #fff;
    padding: 0 15px;
  }

  .config_box {
    width: 100%;
    background-color: #fff;
    min-height: 600px;
    padding: 40px 40px 20px 40px;

    /deep/ .ivu-form-item-label {
      padding-right: 0 !important;
    }

    /deep/ .upload_styles {
      width: 212px;
    }

    .preview_box {
      position: relative;
      width: 210px;
      height: 60px;
      border-radius: 4px;
      /*overflow: hidden;*/
      background: #f5f7fa;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #dcdfe6;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }

      .preview_mask {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        cursor: pointer;
        transition: all 0.3s;
      }

      &:hover .preview_mask {
        opacity: 1;
      }
    }

    .preview_box.ico {
      width: 40px;
      height: 40px;

      .preview_mask {
        width: 210px;
      }
    }


    .upload_icon_box {
      width: 210px;
      height: 60px;
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      color: #999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .languages_check_box {
      display: flex;
      align-items: center;

      .languages_check_boxItem {
        display: flex !important;
        align-items: center;
        margin-right: 30px;
      }
    }
  }

  .options_content {
    box-shadow: 0px -3px 10px 0px #c9cbce;
    position: fixed;
    min-width: 100%;
    z-index: 10;
    background-color: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 12px 35px;
  }
}
</style>
